import { makeStyles } from "@material-ui/core";

export const PricingLookupStyle = makeStyles((theme) => ({
    statusItem: {
        padding: '0.5em 1em',
        cursor: 'pointer',
    },
    selectItem: {
        padding: '0.5em 0',
        fontWeight: '500',
        '&.filled': {
            paddingLeft: '0.5em'
        }
    },
    selectMenu: {
    },
    select: {
        fontSize: '1em',
        padding: 0,
        borderRadius: 0,
        '& fieldset': {
            border: 'none'
        },
    },
    disabledIcon: {
        fill: 'grey'
    },
    pricingMenuPaper: {
        minWidth: 300,
        maxWidth: 520
    },
    pricingMenuItem: {
        alignItems: 'flex-start',
        whiteSpace: 'normal',
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1)
    },
    pricingDetails: {
        width: '100%'
    },
    pricingLine: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'baseline',
        gap: theme.spacing(1),
        '&:not(:last-child)': {
            marginBottom: theme.spacing(0.5)
        }
    },
    pricingLabel: {
        color: theme.palette.text.secondary,
        fontWeight: 500
    },
    pricingValue: {
        color: theme.palette.text.primary,
        fontWeight: 600,
        textAlign: 'right'
    }
}));